<template>
<field :label="label" class="is-grouped is-grouped-multiline">
<div class="control input has-addons" @click="becomeActive"
  :class="{'is-highlighted': highlighted, 'is-danger': error}">
  <div class="wrapper">
    <tag v-for="(tag, index) in value" :label="tag" :key="index"
    @remove="remove(index)" :selected="selectedIndex === index">
    </tag>
    <input type="text" :placeholder="holder" @keydown.prevent.enter="add"
    @keydown.prevent.tab="add" @keydown.delete="onDelete"
    @input="onInput" @focus="onFocus" @blur="onBlur"
    v-model="currentTag" ref="input" />
  </div>
</div>
<transition name="slide-fade">
  <div>
  <p class="help is-danger is-danger-validation error-validation" v-if="error">{{ error }}</p>
  <p class="foot" v-if="highlighted && !error">{{ genFooter }}</p>
  </div>
</transition>
</field>
</template>

<script>
import Field from '@/components/general/field'
import Tag from '@/components/general/tag'
import _ from 'lodash'
_.mixin(require('lodash-inflection'))

export default {
  components: { Field, Tag },
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      default: () => [],
      required: true
    },
    error: {
      type: String,
      default: null
    },
    footer: {
      type: String,
      default: null
    },
    clearOnBlur: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    holder () {
      const length = this.value.length
      if (length > 0) { return '' }
      if (this.placeholder) {
        return this.placeholder
      } else {
        return this.label
      }
    },
    genFooter () {
      if (this.footer === null) {
        return 'Press enter or tab to add your ' + (this.formatLabel(this.label))
      } else return this.footer
    }
  },
  methods: {
    onInput (event) {
      this.selectedIndex = false
    },
    add () {
      if (this.currentTag.length > 0) {
        const pre = this.value || []
        const values = pre.concat([this.currentTag])
        this.currentTag = ''
        this.$emit('input', values)
      }
      this.selectedIndex = NaN
    },
    onDelete () {
      if (this.currentTag === '') {
        if (!isNaN(this.selectedIndex)) {
          const values = this.value
          values.pop()
          this.$emit('input', values)
          this.selectedIndex = values.length - 1
        } else {
          this.selectedIndex = this.value.length - 1
        }
      }
    },
    becomeActive () {
      this.$refs.input.focus()
    },
    remove (index) {
      const values = this.value
      values.splice(index, 1)
      this.$emit('input', values)
    },
    onFocus (event) {
      this.highlighted = true
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.highlighted = false
      if (this.clearOnBlur) {
        this.currentTag = ''
      } else {
        this.add()
      }
      this.$emit('blur', event)
    },
    formatLabel (value) {
      return this.toLower(this.singularize(value))
    },
    singularize (value) {
      return _.singularize(value)
    },
    toLower (value) {
      return _.toLower(value)
    }
  },
  watch: {
    currentTag (newValue) {
      this.$emit('text', newValue)
    }
  },
  data () {
    return {
      currentTag: '',
      selectedIndex: NaN,
      highlighted: false
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  border: 0px;
  min-height: 26px;
  font-size: 0.875rem;
  display: block;
  margin-bottom: 0.5rem;
}

.field {
  overflow: hidden;
  max-width: 100%;
}

.control {
  overflow: hidden;
  display: flex;
}

.tags:not(:last-child) {
  margin-bottom: 0.375rem;
  margin-right: 0.5rem;
}

.is-highlighted {
  border-color: #44c7f0;
}

.input:not(.tag-input), .textarea {
  padding: 0.5rem;
  padding-bottom: 0;
}

input:first-child {
  margin-left: 0.5rem;
}

.input input:active, .input input:focus {
  border: 0;
  outline-style: none;
}

.input {
  height: 100%;
  min-height: 40px;
}

.wrapper {
  width: 100%;
  overflow: visible;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -0.2rem;
  margin-bottom: -0.075rem;

  input:active,
  input:focus {
    box-shadow: none;
  }
}

.field.is-grouped > .control:not(:last-child) {
  margin-bottom: 1.5rem;
}

.field.is-grouped > .control {
  margin-top: 0.5rem;
}

.field.is-grouped.is-grouped-multiline > .control:last-child, .field.is-grouped.is-grouped-multiline > .control:not(:last-child) {
  margin-bottom: 0;
}

.field.is-grouped.is-grouped-multiline:not(:last-child) {
  margin-bottom: 1.5rem;
}
.field.is-grouped.is-grouped-multiline:last-child {
  margin-bottom: 0rem !important;
}

p {
  font-size: 0.75rem;
}

p.foot {
  margin-top: 0.5rem;
  position: absolute;
}

p.error-validation {
  position: absolute;
}

.slide-fade-enter-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/general/tag-text-field.vue